import { http } from '../request'
import { normalizeListResponse } from './shared'

export interface StaffNameDto {
  id: number
  name: string
}

/**
 * 轻量级教职工查询接口，仅返回 id + name。
 * 用于部门负责人选择等场景，避免拉取完整教职工数据。
 */
export const staffLookupApi = {
  async listAllNames(): Promise<StaffNameDto[]> {
    const response = await http.get<StaffNameDto[]>('/data-management-lookup/staff/all-names')
    return normalizeListResponse<StaffNameDto>(response.data)
  }
}
